/**
 * Formats a number for the given locale using the Intl number formatter.
 *
 * Locale-aware so grouping and decimal separators follow the active language
 * (e.g. `1,234.5` in `en` vs `1 234,5` in `pl`).
 *
 * @param value - The number to format
 * @param lang - The language whose locale drives the formatting
 * @returns The locale-formatted number, or an empty string when the value is not a finite number
 *
 * @__NO_SIDE_EFFECTS__
 */
export function formatNumber(value, lang) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return '';
    }
    return new Intl.NumberFormat(lang).format(numeric);
}
//# sourceMappingURL=formatNumber.js.map